import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import nzhcn from 'nzh/cn'
import { Select } from 'antd'
import Module from '~/components/Module'
import SVG from '~/components/SVG'
import { getDynamicByActId } from '~/services'
import dynamicIcon from '~/assets/icon-discuss.svg'
import styles from './index.css'

const DYNAMIC_STATUS_MAP = {
  1: '待启动',
  2: '进行中',
  3: '已结束',
}

export default class Dynamic extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activityId !== nextProps.activityId) {
      return {
        activityId: nextProps.activityId,
      }
    }
    return null
  }
  state = {
    dynamicData: [],
    activityId: this.props.activityId,
  }

  componentDidMount = () => {
    this.loadData()
  }

  componentDidUpdate = prevProps => {
    if (this.props.activityId !== prevProps.activityId) {
      this.loadData()
    }
  }

  loadData = () => {
    const { activityId } = this.state
    if (activityId) {
      getDynamicByActId({ activityId }).then(result => {
        const { data } = result
        this.setState({ dynamicData: data })
      })
    }
  }

  renderDynamicStatus = status => (
    <div
      className={cx(styles.dynamicStatus, {
        [styles.dynamicStatusActive]: status === 2,
      })}
    >
      {DYNAMIC_STATUS_MAP[status]}
    </div>
  )

  renderPeriodItem = ({ subList = [], title } = {}) => (
    <div key={`dynamics_${title}`} className={styles.dynamicList}>
      <header className={styles.dynamicListTitle}>{title}</header>
      <div className={styles.dynamicListContent}>
        {subList.map(subItem => {
          const SubItemComponent = subItem.status !== 1 ? Link : 'div'

          return (
            <SubItemComponent
              key={`dynamicItem_${subItem.id}`}
              className={styles.dynamicItem}
              {...(subItem.status !== 1
                ? {
                    to: `/activity/${this.state.activityId}?dynamicId=${
                      subItem.id
                    }`,
                  }
                : {})}
            >
              <div
                className={cx(styles.dynamicTitleWrap, {
                  [styles.dynamicTitleWrapInactive]: subItem.status === 1,
                })}
              >
                <span className={styles.dynamicNum}>
                  第{nzhcn.encodeS(subItem.period)}期：
                </span>
                <span className={styles.dynamicTitle}>{subItem.title}</span>
              </div>
              {this.renderDynamicStatus(subItem.status)}
            </SubItemComponent>
          )
        })}
      </div>
    </div>
  )

  render() {
    const { dynamicData } = this.state
    const { showType, currentDynamicId, changeDynamicId } = this.props

    if (!dynamicData || !dynamicData.length) {
      return null
    }

    const allDynamicData = dynamicData.reduce((a, b) => a.concat(b.subList), [])

    return (
      <Module
        headerIcon={<SVG src={dynamicIcon} width={17} height={17} />}
        className={cx({ [styles.dynamicFlow]: showType === 1 })}
        headerText="活动讨论"
      >
        {showType === 1 ? (
          <Select
            className={styles.dynamicSelect}
            value={currentDynamicId}
            onChange={value => changeDynamicId(value)}
          >
            {allDynamicData.map((item, index) => (
              <Select.Option value={item.id} key={item.id}>
                {`第${index + 1}期`}
              </Select.Option>
            ))}
          </Select>
        ) : (
          <div className={styles.dynamicLists}>
            {dynamicData.map(this.renderPeriodItem)}
          </div>
        )}
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Dynamic/index.js